export default "__VITE_ASSET__CJc8BC_0__"